import React from "react";
import { NextPageContext } from "next";
import Link from "next/link";
import Head from "next/head";

import styles from "../../styles/error.scss";

export default class Error extends React.Component<any> {
  static getInitialProps({ res, err }: NextPageContext) {
    const statusCode = res ? res.statusCode : err ? err.statusCode : null;
    return { statusCode };
  }
  render() {
    return (
      <div className="rotoql-content-error__container">
        <Head>
          <title>Error</title>
          <meta name="robots" content="noindex,follow" />
          <meta name="googlebot" content="noindex,follow" />
        </Head>
        <div className="rotoql-content-error__text-container">
          {this.props.statusCode ? (
            <h1 className="rotoql-content-error__title">{this.props.statusCode}</h1>
          ) : (
            <h1>Error</h1>
          )}
          <Link href="/" legacyBehavior>
            <a className="rotoql-content-error__link">Go Home</a>
          </Link>
        </div>
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }
}
